export var getQS = () => {
  let qs = {}
  let search = (window.location.search || '').replace(/^\?/, '') + '&'
  search.replace(/^\?/, '').replace(/([^=]+?)=(.+?)&/g, (f, n, v) => qs[n] = v)
  return qs
}

export var qs = getQS()
